import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from "react-dom/client";
import { islandRegistry } from "./islands/registry";

function mountIslands() {
  if (
    islandRegistry.length !== new Set(islandRegistry.map(({ key }) => key)).size
  ) {
    throw new Error("Island registry has duplicate keys");
  }

  islandRegistry.forEach(({ key, component }) => {
    const roots = document.querySelectorAll(`[id^="react-${key}"]`);
    if (roots) {
      roots.forEach((root) => {
        const jsonEl = root.querySelector(`script[data-react-${key}-props]`);
        const props = jsonEl ? JSON.parse(jsonEl.textContent || "{}") : {};
        const r = createRoot(root);
        r.render(_jsx(component, { ...props }));
      });
    }
  });
}

mountIslands();
